import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, Spinner } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { openModal, closeModal } from '../../components/modal/actions';

const DeleteModal = ({ addressId, handleDelete, submitting, openModal, closeModal }) => {
  const handleConfirm = () => {
    handleDelete(addressId);
    closeModal();
  };

  const handleDeleteClick = () => {
    openModal({
      type: 'alert',
      content: <TranslatedCopy id='addressBook.form.delete.copy' />,
      confirmText: <TranslatedCopy id='addressBook.form.delete.title' />,
      confirmAction: handleConfirm,
      cancelText: <TranslatedCopy id='global.cancel' />,
      cancelAction: closeModal
    });
  };

  return (
    <Button
      secondary
      onClick={handleDeleteClick}
      extraClassName='full-width'
      data-desc='addressBookForm__button_delete'
    >
      {submitting ? (
        <Spinner className='relative-container p3-sm' />
      ) : (
        <TranslatedCopy id='addressBook.form.delete.title' />
      )}
    </Button>
  );
};

DeleteModal.defaultProps = {
  submitting: false
};

DeleteModal.propTypes = {
  addressId: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

const connector = connect(() => ({}), {
  openModal,
  closeModal
});

export default connector(DeleteModal);
